// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"7c9105ae","297":"6d308c88","643":"3c90b91b","959":"873ff0cc"}[chunkId] + ".chunk.js";
};